import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ExploreDeepWaters from "./sections/ExploreDeepWaters";
import SanctuariesOfPeace from "./sections/SanctuariesOfPeace";
import ReliabilityByTheNumbers from "./sections/ReliabilityByTheNumbers";
import PourquoiChoisirCloudMedia from "./sections/PourquoiChoisirCloudMedia";
import In3SchrittenZuIhremNeuenZuhause from "./sections/In3SchrittenZuIhremNeuenZuhause";
import BriefOurAnalysts from "./sections/BriefOurAnalysts";
import SiteFooter from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ExploreDeepWaters />
      <SanctuariesOfPeace />
      <ReliabilityByTheNumbers />
      <PourquoiChoisirCloudMedia />
      <In3SchrittenZuIhremNeuenZuhause />
      <BriefOurAnalysts />
      <SiteFooter />
    </div>;
}